import { render, staticRenderFns } from "./Tip1.vue?vue&type=template&id=6643b1c2&scoped=true&lang=pug&"
import script from "./Tip1.vue?vue&type=script&lang=ts&"
export * from "./Tip1.vue?vue&type=script&lang=ts&"
import style0 from "./Tip1.vue?vue&type=style&index=0&id=6643b1c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643b1c2",
  null
  
)

export default component.exports